import { useState } from 'react'
import { Box, Button, Flex, Image, Text, VStack } from '@chakra-ui/react'
import { IconContext } from 'react-icons'
import * as MdIcons from 'react-icons/md'
import PropTypes from 'prop-types'
import { useAppContext } from 'hooks/useAppContext'
import { getAssetUrl } from 'lib'
import { ROLENAMES } from 'lib/role'
import { MenuDirectory } from './data'
import { useLocation, useNavigate } from 'react-router-dom'

export const SideMenu = (props) => {
  const location = useLocation()
  const curPath = location.pathname

  const { currentUser } = useAppContext()

  return (
    <Box
      w="250px"
      bg="blue.600"
      py={10}
      {...props}
    >
      <Flex columnGap={4} alignItems="center" mb={10} px={4}>
        <Image w="64px" h="64px" borderRadius="full" src={getAssetUrl(currentUser?.image)} />
        <Box>
          <Text fontSize="lg" fontWeight="bold" color="white">{currentUser?.firstname} {currentUser?.lastname}</Text>
          <Text fontSize="sm" color="white">{ROLENAMES?.[currentUser?.group]}</Text>
        </Box>
      </Flex>
      <VStack rowGap={4}>
        {MenuDirectory.map(section => {
          const sectionItems = section.items.map(pItem => {
            let subItems = []
            if (pItem.parent) {
              subItems = pItem.items.filter(v => v.roles.includes(currentUser?.role)).map(sItem => <SideMenuSecondaryItem key={sItem.label} label={sItem.label} path={sItem.path} active={curPath === sItem.path} />)
            }
            if ((pItem.parent && subItems.length > 0) ||
                (!pItem.parent && pItem.roles.includes(currentUser?.role))
            ) {
              return (
                <SideMenuPrimaryItem
                  key={pItem.label}
                  curPath={curPath}
                  parent={pItem.parent}
                  icon={pItem.icon}
                  label={pItem.label}
                  path={pItem.path}
                >
                  {subItems}
                </SideMenuPrimaryItem>
              )
            } else {
              return null
            }
          }).filter(v => v)

          if (sectionItems.length > 0) {
            return (
              <Box key={section.label} w="100%">
                <Text size="md" fontWeight="bold" px={4} color="white" mb={2}>{section.label}</Text>
                {sectionItems}
              </Box>
            )
          } else {
            return null
          }
        })}
      </VStack>
    </Box>
  )
}

export const SideMenuPrimaryItem = ({ curPath = '', parent, icon, label, path, children, ...rest }) => {
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(parent ? curPath.indexOf(path) === 0 : false)

  if (parent) {
    return (
      <>
        <Button
          px={4}
          w="100%"
          variant="ghost"
          colorScheme="gray"
          justifyContent="space-between"
          rightIcon={isOpen ? <MdIcons.MdExpandLess color="white" size="18px" /> : <MdIcons.MdExpandMore color="white" size="18px" />}
          onClick={() => setIsOpen(!isOpen)}
          // bg={isOpen ? 'blue.300' : 'transparent'}
          _hover={{ bg: 'blue.400' }}
          {...rest}
        >
          <Flex columnGap={3}>
            <DynamicIcon iconName={icon} />
            <Text color="white" fontWeight="normal">{label}</Text>
          </Flex>
        </Button>
        {isOpen && (
          <VStack pl={12} rowGap={2} py={2} textALign="left">
            {children}
          </VStack>
        )}
      </>
    )
  } else {
    return (
      <a href={path} onClick={e => e.preventDefault()}>
        <Button
          px={4}
          w="100%"
          variant="ghost"
          colorScheme="white"
          justifyContent="flex-start"
          onClick={() => navigate(path)}
          bg={curPath === path ? 'blue.300' : 'transparent'}
          _hover={{ bg: 'blue.400' }}
          {...rest}
        >
          <Flex columnGap={3}>
            <DynamicIcon iconName={icon} />
            <Text color="white" fontWeight="normal">{label}</Text>
          </Flex>
        </Button>
      </a>
    )
  }
}

SideMenuPrimaryItem.propTypes = {
  curPath: PropTypes.string,
  parent: PropTypes.bool.isRequired,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  path: PropTypes.string,
  children: PropTypes.node
}

export const SideMenuSecondaryItem = ({ active, label, path }) => {
  const navigate = useNavigate()

  return (
    <a href={path} onClick={e => e.preventDefault()}>
      <Button
        w="100%"
        justifyContent="flex-start"
        variant="ghost"
        colorScheme="white"
        px={0}
        py={0}
        h={6}
        onClick={() => navigate(path)}
        _hover={{ opacity: 0.8 }}
      >
        <Text
          color="white"
          fontWeight={active ? 'bold' : 'normal'}
          fontSize="sm"
        >
          {label}
        </Text>
      </Button>
    </a>
  )
}

SideMenuSecondaryItem.propTypes = {
  active: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired
}

export const DynamicIcon = ({ iconName }) => {
  const Icon = MdIcons[iconName]

  return (
    <IconContext.Provider value={{ size: '20px', color: 'white' }}>
      {Icon ? <Icon /> : null}
    </IconContext.Provider>
  )
}

DynamicIcon.propTypes = {
  iconName: PropTypes.string.isRequired
}
